import { useState } from 'react';
import { getHideAssessmentInfoModalPreferenceAdminOrCoord } from './utils';

export const useDigitalAssessmentInfoModal = ({ userPreferences }) => {
  const [digitalAssessmentInfoModalOpen, setDigitalAssessmentInfoModalOpen] =
    useState(true);
  const hideDigitalAssesmentUserPreferenceExists =
    getHideAssessmentInfoModalPreferenceAdminOrCoord(userPreferences);
  return {
    digitalAssessmentInfoModalOpen,
    setDigitalAssessmentInfoModalOpen,
    hideDigitalAssesmentUserPreferenceExists,
  };
};

export default useDigitalAssessmentInfoModal;
